const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/boxes/$boxId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
export const Route = createFileRoute('/(app)/org/$org/settings/boxes/$boxId/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    context: {
      flags
    }
  }) => {
    if (!flags.itemStorePermissionLookup) {
      throw notFound();
    }
  },
  loader: async (): Promise<LoaderData> => {
    return {
      crumb: i18n.t('common.settings.boxes.boxSettings')
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t('common.settings.boxes.boxSettings')
    }
  }
});